import {useMutation} from '@tanstack/react-query';

import {TypeLocalNameEnum} from 'domain/usecases';
import {EntryPointCodeEnum} from 'presentation/constants/entryPointCodeEnum';
import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';
import {useQueryParams} from 'presentation/pages';
import {getHealthUnits} from '../../services/getHealthUnits';
import {MIN_DISTANCE_IN_KM_HEALTH} from 'presentation/modules/booking/health/ui/components/HealthSearchBar/hooks/useHealthSearchBar/constants';

export function useGetHealthUnitsMutation() {
	const bookingData = useBookingStore(state => state.bookingData);

	const {
		SEARCH_PARAMS: {localityDistance},
	} = useQueryParams();

	const {
		specialtyCode,
		subSpecialtyCode,
		ufCode,
		isManualLocation,
		coordinates,
		cityName,
		typeLocalName,
		districtName,
		citiesNames,
		professionalCode,
		isFavoriteDoctorsFlow,
	} = bookingData;

	const isUsingGeolocation = !isManualLocation;

	const distance = () => {
		if (isUsingGeolocation) {
			return localityDistance || MIN_DISTANCE_IN_KM_HEALTH;
		}
		return !localityDistance && districtName ? undefined : localityDistance;
	};

	const params = {
		specialtyCode: String(specialtyCode),
		subSpecialtyCode: subSpecialtyCode ? String(subSpecialtyCode) : '',
		stateCode: isUsingGeolocation ? undefined : ufCode?.toUpperCase(),
		cityName: isUsingGeolocation ? coordinates : cityName?.toUpperCase(),
		distance: distance(),
		typeLocalName: typeLocalName || TypeLocalNameEnum.CIDADE,
		entryPointCode: Number(EntryPointCodeEnum.V2),
		districtNames: districtName && !localityDistance ? districtName?.toUpperCase() : undefined,
		citiesNames: citiesNames && !localityDistance ? citiesNames : undefined,
		providerCode:
			isFavoriteDoctorsFlow && professionalCode ? String(professionalCode) : undefined,
		isFavoriteDoctorsFlow,
	};

	return useMutation({
		mutationFn: ({signal}: {signal?: AbortSignal}) => getHealthUnits({signal, ...params}),
	});
}
